import axios from '@/api/config';

const liveMaterials = {
  getLiveMaterialsById(data) {
    return axios.get(`${process.env.BASE_URL}/liveMaterials/getLiveMaterials/` + data, {});
  },
  getLiveMaterialsDetail(data) {
    return axios.get(`${process.env.BASE_URL}/liveMaterials/getLiveMaterialsDetail`, {params: data});
  },
  getLiveMaterials(data) {
    return axios.get(`${process.env.BASE_URL}/liveMaterials/getLiveMaterials`, {params: data});
  },
  getAttachmentList(data) {
    return axios.get(`${process.env.BASE_URL}/liveMaterials/getAttachmentList`, {params: data});
  },
  getLiveMaterialsList(data) {
    return axios.get(`${process.env.BASE_URL}/liveMaterials/getLiveMaterialsList`, {params: data});
  },
  getLiveMaterialsTree(data) {
    return axios.get(`${process.env.BASE_URL}/liveMaterials/getLiveMaterialsTree`, {params: data});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/liveMaterials/pageList`, data);
  },
  addLiveMaterials(data) {
    return axios.post(`${process.env.BASE_URL}/liveMaterials/addLiveMaterials`, data);
  },
  updateLiveMaterials(data) {
    return axios.put(`${process.env.BASE_URL}/liveMaterials/updateLiveMaterials`, data);
  },
  deleteLiveMaterials(data) {
    return axios.delete(`${process.env.BASE_URL}/liveMaterials/deleteLiveMaterials`,  {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/liveMaterials/exportExcel`, {params: data});
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/liveMaterials/importData`, data);
  },
  active(data) {
    return axios.post(`${process.env.BASE_URL}/liveMaterials/active`, data);
  },
}

export default liveMaterials;



// WEBPACK FOOTER //
// ./src/api/liveMaterials.js